export default {
      id: "download-usage",
      viewBox: "0 0 512 512",
      url: "../../assets/" + "sprite.svg#download-usage",
      toString: function () {
        return this.url;
      }
    }